module.exports = __webpack_public_path__ + "static/media/HouseGraphic.e27cd7e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-screen/HouseGraphic.svg
// module id = 378
// module chunks = 0